import { Button } from '@/components/ui/button';
import { useChatStore } from '@/stores/chat-store';
import { MessageCircleMore } from 'lucide-react';
import { motion } from 'motion/react';
import { cn } from '@/utils';

interface ChatButtonProps {
	className?: string;
}

const chatButtonBase =
	'relative inline-flex size-5 items-center justify-center rounded-full border border-border/60 bg-card/70 p-0 text-foreground shadow-sm transition hover:border-primary/40 hover:bg-card/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:ring-offset-2 focus-visible:ring-offset-background overflow-visible';

export function ChatButton({ className }: ChatButtonProps = {}) {
	const toggle = useChatStore((s) => s.toggle);
	const unreadCount = useChatStore((s) => Object.values(s.unreadByChannel ?? {}).reduce((a, b) => a + (b ?? 0), 0));
	const unreadLabel = unreadCount > 99 ? '99+' : unreadCount ? `${unreadCount}` : null;
	const unreadKey = unreadCount > 0 ? String(unreadCount) : '0';
	return (
		<Button variant="ghost" className={cn(chatButtonBase, className)} onClick={toggle} aria-label="Open chat">
			<MessageCircleMore />
			{unreadLabel ? (
				<motion.span
					key={unreadKey}
					initial={{ scale: 1, y: -2 }}
					animate={{ scale: [1, 1.12, 1], y: 0 }}
					transition={{ duration: 0.35, times: [0, 0.4, 1] }}
					exit={{ scale: 0.6, opacity: 0, y: -4, transition: { duration: 0.2 } }}
					className="pointer-events-none absolute -right-1 -top-1 inline-flex min-w-5 items-center justify-center rounded-full bg-destructive/90 px-1.5 text-xs font-semibold text-inverted-foreground shadow"
				>
					{unreadLabel}
				</motion.span>
			) : null}
		</Button>
	);
}
